/* SaphirSHIELD Front-Blende (02.10.2026) - Logik fuer Kaufbox (edelholz-pdp-minikonfigurator) und Konfigurator B
   (desk-con-apple-b). Die Sections haben nur kurze Haken (window.EhSaphir && EhSaphir.x(...)) und melden sich
   ueber window.EHS_Q an: { typ: 'kb' | 'b', root, state, ... }. Daten: snippets/edelholz-saphir-daten.liquid.

   Verhalten (Philipp 02.10.):
   - Blende gewaehlt: Galerie/Buehne zeigt ZUERST das Saphir-Set der Holzart (Studio schraeg, Motiv, Kabelseite,
     Frontansicht, Vogelperspektive) mit kleinem Label "mit SaphirSHIELD", danach die normalen Bilder OHNE
     Kabelfach-/CableHIDE-Bilder. Holzartwechsel tauscht das Set, Abwaehlen = alles wie vorher.
   - Konfigurator B, Zusammenfassung (Box 6): NUR das Saphir-Set (Haken in edelholz-konfigurator-b-verhalten.js).
   - CableHIDE-Karte / "Kabelfach inklusive" -> "Kabelwanne statt Kabelfach" (05.10.: Metall-Kabelwanne, kein Technikbrett). Oberer Durchlass "Keine" gesperrt,
     war er gewaehlt, springt er auf Mittig (kurzer Hinweis).
   - Warenkorb: Saphir-Zeile "Farbe" + "Passend zu" + _bild (edelholz-addon-bild.js, Motiv saphirshield),
     am Tisch sichtbar "Kabelfach: ersetzt durch Kabelwanne aus Metall (SaphirSHIELD)".
   - Angebot: choice/choiceLabel = Farbe, damit Entwurf und PDF die Blende mit Farbe nennen.
   - 06.10. (Philipp): SoftGLOW ergibt mit der Blende keinen Sinn (das Lichtband sitzt in der Zarge hinter der Blende).
     Blende gewaehlt -> SoftGLOW-Karte ausgeblendet; war SoftGLOW schon gewaehlt, wird es abgewaehlt (kurzer Hinweis). */
(function () {
  'use strict';
  var KEY = 'saphir';
  var WEG = 'softglow'; /* Add-on, das mit der Blende nicht waehlbar ist */
  var WEG_HINWEIS = 'SoftGLOW wurde entfernt: mit SaphirSHIELD nicht kombinierbar.';
  var KABEL = /kabelmanagement|cablehide|kabelfach/i;
  /* 05.10.26 (Philipp): Mit Blende keine Doppelungen. Das Saphir-Set zeigt Studio schraeg, Motiv, Frontansicht und
     Vogelperspektive schon, darum fallen die gleichen Ansichten ohne Blende und die cleanen Studiobilder weg. */
  var DOPPELT = /(^|\/)(deskpro|deskpure)-(motiv|vogelperspektive|frontansicht)-|(^|\/)EDELHOLZDesk(PRO|PURE)Schreibtisch/i;
  function datei(u) { return String(u || '').split('?')[0].split('/').pop(); }
  /* 05.10.26 (Philipp): Die Kabelwanne sitzt unter der Tischplatte und haengt nicht am oberen Durchlass,
     darum keine Sperre von "Keine" mehr. Code bleibt, falls es wieder gebraucht wird. */
  var DURCHLASS_SPERRE = false;
  var cache = null;

  function daten() {
    if (cache) return cache;
    try { var el = document.querySelector('[data-eh-saphir-daten]'); cache = el ? JSON.parse(el.textContent) : null; } catch (e) { cache = null; }
    return cache;
  }
  function slug(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function holz(state) {
    var d = daten(), s = slug(state && state.finish);
    return (d && d.bilder && d.bilder[s]) ? s : 'golden-timber';
  }
  function setUrls(state) { var d = daten(); return (d && d.bilder && d.bilder[holz(state)]) || []; }
  function breite(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function istSaphirUrl(u) { return /\/saphirshield-/i.test(String(u || '')); }
  function ctxVon(root) { return root && root.__ehs; }
  function an(ctx) {
    if (!ctx || !ctx.state) return false;
    var a = (ctx.state.addons || {})[KEY];
    if (ctx.typ === 'b') return !!(a && a.selected) && ctx.state.modelKey !== 'ArcPURE';
    return !!a;
  }
  function hinweis(host, text, nach) {
    if (!host) return;
    var p = host.parentNode && host.parentNode.querySelector(':scope > .eh-saphir-hinweis');
    if (!text) { if (p) p.remove(); return; }
    if (!p) { p = document.createElement('p'); p.className = 'eh-saphir-hinweis'; host.parentNode.insertBefore(p, nach ? host.nextSibling : host); }
    if (p.textContent !== text) p.textContent = text;
  }
  function label(el) {
    if (!el || el.querySelector(':scope > .eh-saphir-label')) return;
    var d = daten() || {};
    var s = document.createElement('span'); s.className = 'eh-saphir-label'; s.textContent = d.label || 'mit SaphirSHIELD';
    el.appendChild(s);
  }

  var API = {
    /* ---------- gemeinsam ---------- */
    an: function (root) { return an(ctxVon(root)); },
    /* Warenkorb-Props: Saphir-Zeile + Tisch. items[0] ist in beiden Sections der Tisch. */
    props: function (items, root) {
      var ctx = ctxVon(root); if (!an(ctx) || !items || !items.length) return;
      var d = daten() || {};
      var a = ctx.state.addons[KEY] || {};
      var vid = String(a.variantId || '');
      items.forEach(function (it, i) {
        if (!i || String(it.id) !== vid) return;
        var p = it.properties = it.properties || {};
        var fin = ctx.state.finish || '';
        p.Farbe = d.farbe || 'Graphitschwarz RAL 9011 seidenmatt';
        if (fin) p['Passend zu'] = fin;
        delete p.Finish;
        var u = setUrls(ctx.state)[0];
        if (!p._bild && u) { p._bild = breite(u, 360); p._finish = fin; }
      });
      var t = items[0].properties = items[0].properties || {};
      t.Kabelfach = d.kabelfachProp || 'ersetzt durch Kabelwanne aus Metall (SaphirSHIELD)';
    },
    /* Popup-Bilder: Saphir-Set der Holzart + Video. 05.10. (Philipp): Showroom-Clip Stefan Pop statt Werkstatt-Clip,
       Ausschnitt 1 bis 21 s wie auf der Add-on-Seite (start/ende, snippets/edelholz-produkt-popup.liquid). */
    popBilder: function (state, w) {
      var d = daten() || {};
      var b = setUrls(state).map(function (u) { return breite(u, w || 900); });
      var v = d.video;
      if (v && v.src) b.push({ video: { src: v.src, poster: v.poster || '', start: v.start || 0, ende: v.ende || 0, alt: v.alt || 'SaphirSHIELD' } });
      return b;
    },

    /* ---------- Kaufbox ---------- */
    /* Haken am Anfang von render(): Zustand anwenden, bei Wechsel die Galerie neu ordnen. */
    kb: function (root) {
      var ctx = ctxVon(root); if (!ctx) return;
      var on = an(ctx), d = daten() || {}, st = ctx.state;
      if (on && st.addons[KEY]) st.addons[KEY].choiceLabel = d.farbe;
      /* oberer Durchlass */
      if (DURCHLASS_SPERRE) root.querySelectorAll('[data-mk-feature]').forEach(function (grp) {
        if (!/ober/i.test(grp.getAttribute('data-mk-feature') || '')) return;
        var keine = grp.querySelector('[data-mk-choice="keine"]');
        if (!keine) return;
        var reset = false;
        if (on && keine.classList.contains('aktiv')) {
          var mitte = grp.querySelector('[data-mk-choice="zentriert"]');
          if (mitte) { mitte.click(); reset = true; }
        }
        keine.disabled = on; keine.classList.toggle('eh-saphir-gesperrt', on);
        keine.title = on ? (d.durchlassHinweis || '') : '';
        if (reset) ctx.reset = true;
        if (!on) ctx.reset = false;
        hinweis(grp, on ? (ctx.reset ? d.durchlassReset : d.durchlassHinweis) : '', true);
      });
      /* SoftGLOW-Karte: mit Blende weg, war es gewaehlt -> abwaehlen + Hinweis an der Saphir-Karte */
      (function () {
        var pill = root.querySelector('[data-mk-addon="' + WEG + '"]');
        var karte = pill && pill.closest('[data-mk-addon-karte]');
        if (!karte) return;
        var sp = root.querySelector('[data-mk-addon="' + KEY + '"]');
        var sk = sp && sp.closest('[data-mk-addon-karte]');
        var mitte = sk && sk.querySelector('.eh-mk__zeile-mitte');
        /* Saphir-Karte hat keine "Mehr erfahren"-Zeile: Hinweis dann hinter das letzte Element der Mitte */
        var mehr = mitte && (mitte.querySelector('.eh-mk__zeile-mehr') || mitte.lastElementChild);
        if (on && st.addons[WEG]) {
          delete st.addons[WEG]; pill.classList.remove('aktiv'); pill.textContent = 'Hinzufügen';
          ctx.wegReset = true;
        }
        if (!on) ctx.wegReset = false;
        karte.hidden = on; karte.style.display = on ? 'none' : '';
        if (mehr) hinweis(mehr, (on && ctx.wegReset) ? WEG_HINWEIS : '', true);
      })();
      /* CableHIDE-Karte */
      root.querySelectorAll('[data-mk-inklusive-karte]').forEach(function (k) {
        var tag = k.querySelector('.eh-mk__tag'), mitte = k.querySelector('.eh-mk__zeile-mitte');
        if (tag) {
          var tn = tag.lastChild;
          if (tn && tn.nodeType === 3) { if (!tag.__ehsText) tag.__ehsText = tn.textContent; tn.textContent = on ? 'Ersetzt' : tag.__ehsText; }
        }
        var mehr = mitte && mitte.querySelector('.eh-mk__zeile-mehr');
        if (mehr) hinweis(mehr, on ? d.inklusiveHinweis : '', false);
      });
      if (ctx.letzt !== on) { var erst = ctx.letzt === undefined; ctx.letzt = on; if (!erst && ctx.gal) try { ctx.gal(); } catch (e) {} }
    },
    /* "Kabelfach inklusive" in der Ausstattungszeile */
    kf: function (root) { var d = daten() || {}; return an(ctxVon(root)) ? (d.kabelfach || 'Kabelwanne statt Kabelfach') : ''; },
    /* Haken in galFilter(): ordnet die (serverseitig gerenderten, versteckten) Saphir-Slides und -Thumbs nach vorn
       und liefert die Regel "Slide raus?". null = Kaufbox ohne Saphir. */
    kbGal: function (root, spur) {
      var ctx = ctxVon(root); if (!ctx || !spur) return null;
      var on = an(ctx), fin = holz(ctx.state);
      if (on) {
        var sl = [].slice.call(spur.querySelectorAll('[data-mk-slide][data-mk-saphir="' + fin + '"]'));
        /* Bild 1 des Sets sofort laden (lazy wartet sonst, bis der Slide sichtbar war) */
        sl.forEach(function (x, n) { var im = x.querySelector('img'); if (im && n < 2) im.loading = 'eager'; });
        for (var i = sl.length - 1; i >= 0; i--) spur.insertBefore(sl[i], spur.firstChild);
        var th = [].slice.call(root.querySelectorAll('[data-mk-thumb][data-mk-saphir="' + fin + '"]'));
        for (var j = th.length - 1; j >= 0; j--) { th[j].parentNode.insertBefore(th[j], th[j].parentNode.firstChild); var ti = th[j].querySelector('img'); if (ti) ti.loading = 'eager'; }
      }
      return function (s) {
        var f = s.getAttribute('data-mk-saphir');
        if (f) return !on || f !== fin;
        if (!on) return false;
        var im = s.querySelector('img');
        var src = (im && (im.getAttribute('src') || im.getAttribute('data-src'))) || '';
        return KABEL.test((s.getAttribute('data-mk-alt') || '') + ' ' + src) || DOPPELT.test(datei(src));
      };
    },
    pop: function (key, bilder, root) {
      var ctx = ctxVon(root);
      return (ctx && key === KEY) ? API.popBilder(ctx.state, 900) : bilder;
    },

    /* ---------- Konfigurator B ---------- */
    /* Haken in renderImageSubset(): Saphir-Set vorn, Kabelfach-Bilder raus. Positionen fuer die Video-Einsortierung
       (EHBVideo.letztePositionen) werden mitgefuehrt, damit das Video nicht zwischen die Saphir-Bilder rutscht. */
    bSubset: function (subset, state, root) {
      var ctx = ctxVon(root) || { typ: 'b', state: state };
      if (!an(ctx) || !subset) return subset;
      var V = window.EHBVideo, pos = (V && V.letztePositionen) || [];
      var neu = [], np = [];
      subset.forEach(function (u, i) {
        if (i > 0 && KABEL.test(datei(u))) return;
        if (DOPPELT.test(datei(u))) return;
        neu.push(u); np.push(i === 0 ? 0.1 : (pos[i] || 0));
      });
      var set = setUrls(state).map(function (u) { return breite(u, 1000); });
      if (V) V.letztePositionen = set.map(function () { return 0.1; }).concat(np);
      return set.concat(neu);
    },
    bZellen: function (cells) {
      (cells || []).forEach(function (c) {
        var im = c.querySelector('img');
        var u = im && (im.getAttribute('src') || im.getAttribute('data-flickity-lazyload'));
        if (istSaphirUrl(u)) { c.classList.add('eh-saphir-zelle'); label(c); }
      });
    },
    /* Haken am Ende von renderFeatures(): CableHIDE-Karte + oberer Durchlass */
    bFeatures: function (list, state) {
      if (!list) return;
      var ctx = ctxVon(list.closest('[id^="desk-configurator-"]')) || { typ: 'b', state: state };
      var on = an(ctx), d = daten() || {};
      if (on && state.addons[KEY]) state.addons[KEY].choice = d.farbe;
      list.querySelectorAll('.eh-feature-card').forEach(function (card) {
        var titel = ((card.querySelector('.eh-feature-title') || {}).textContent || '').trim();
        if (card.classList.contains('eh-feature-card--inklusive')) {
          var tag = card.querySelector('.eh-feature-tag');
          if (tag && on) { var tn = tag.lastChild; if (tn && tn.nodeType === 3) tn.textContent = 'Ersetzt'; }
          var body = card.querySelector('.eh-feature-body');
          if (body && on) { var p = document.createElement('p'); p.className = 'eh-saphir-hinweis'; p.textContent = d.inklusiveHinweis || ''; body.appendChild(p); }
          return;
        }
        if (!/^oberer kabeldurchlass$/i.test(titel)) return;
        if (!DURCHLASS_SPERRE) return;
        var fk = Object.keys(state.features || {}).filter(function (k) { return /^oberer/i.test(k); })[0];
        var chips = [].slice.call(card.querySelectorAll('.eh-chip'));
        var keine = chips.filter(function (c) { return /^keine$/i.test(c.textContent.trim()); })[0];
        var mitte = chips.filter(function (c) { return /^mittig$/i.test(c.textContent.trim()); })[0];
        if (!keine) return;
        if (!on) { ctx.reset = false; return; }
        if (fk && String(state.features[fk]).toLowerCase() === 'keine' && mitte) {
          state.features[fk] = 'zentriert';
          chips.forEach(function (c) { c.classList.toggle('is-selected', c === mitte); c.setAttribute('aria-checked', c === mitte ? 'true' : 'false'); });
          ctx.reset = true;
        }
        keine.disabled = true; keine.classList.add('is-disabled', 'eh-saphir-gesperrt'); keine.title = d.durchlassHinweis || '';
        var b2 = card.querySelector('.eh-feature-body');
        if (b2) { var h = document.createElement('p'); h.className = 'eh-saphir-hinweis'; h.textContent = ctx.reset ? d.durchlassReset : d.durchlassHinweis; b2.appendChild(h); }
      });
    },
    /* Haken am Ende von renderAddons() und nach jedem Umschalten der Blende: SoftGLOW-Karte weg, Auswahl loeschen. */
    bAddons: function (list, state) {
      if (!list) return;
      var root = list.closest('[id^="desk-configurator-"]');
      var ctx = ctxVon(root) || { typ: 'b', state: state };
      var on = an(ctx);
      var card = list.querySelector('[data-ehb-addon="' + WEG + '"]');
      var sap = list.querySelector('[data-ehb-addon="' + KEY + '"]');
      var a = (state.addons || {})[WEG];
      if (on && a && a.selected) {
        a.selected = false;
        if (card) {
          var chk = card.querySelector('input'); if (chk) chk.checked = false;
          card.classList.remove('is-selected');
          var stt = card.querySelector('.eh-addon-status'); if (stt) stt.textContent = '';
        }
        ctx.wegReset = true;
      }
      if (!on) ctx.wegReset = false;
      if (card) card.hidden = on;
      var body = sap && sap.querySelector('.eh-feature-body');
      if (body) {
        var h = body.querySelector(':scope > .eh-saphir-hinweis--weg');
        if (on && ctx.wegReset) {
          if (!h) { h = document.createElement('p'); h.className = 'eh-saphir-hinweis eh-saphir-hinweis--weg'; body.appendChild(h); }
          h.textContent = WEG_HINWEIS;
        } else if (h) h.remove();
      }
    },
    bPop: function (key, bilder, state) { return key === KEY ? API.popBilder(state, 900) : bilder; },
    /* Zusammenfassung B: nur das Saphir-Set */
    nurSet: function (liste, root) {
      if (!an(ctxVon(root))) return liste;
      var nur = (liste || []).filter(function (e) { return typeof e === 'string' && istSaphirUrl(e); });
      return nur.length ? nur : liste;
    }
  };

  /* B: Umschalten der Blende erkennen (Checkbox im Add-on-Schritt) und Buehne, Ausstattung, Zusammenfassung nachziehen. */
  function bAnmelden(ctx) {
    ctx.letzt = an(ctx);
    ctx.root.addEventListener('change', function () {
      setTimeout(function () {
        var on = an(ctx);
        if (on === ctx.letzt) return;
        ctx.letzt = on;
        if (!on) ctx.reset = false;
        try { API.bAddons(ctx.root.querySelector('[data-role="addon-list"]'), ctx.state); } catch (e) {}
        try { if (ctx.feat) ctx.feat(); } catch (e) {}
        try { if (ctx.bild) ctx.bild(); } catch (e) {}
        try { if (ctx.sum) ctx.sum(); } catch (e) {}
      }, 0);
    });
    /* Label auf den Schritt-Bildboxen, wenn sie gerade ein Saphir-Bild zeigen */
    var boxen = ctx.root.querySelectorAll('[data-ehb-bild]');
    var markiere = function () {
      [].forEach.call(boxen, function (box) {
        var im = box.querySelector('.ehb-bild__img');
        var ja = !!(im && istSaphirUrl(im.getAttribute('src')) && im.offsetParent !== null && !box.querySelector('video:not([hidden])'));
        var host = im && im.parentElement;
        var l = host && host.querySelector(':scope > .eh-saphir-label');
        if (ja && host && !l) { host.classList.add('eh-saphir-zelle'); label(host); }
        if (!ja && l) l.remove();
      });
    };
    if (window.MutationObserver) [].forEach.call(boxen, function (box) {
      new MutationObserver(markiere).observe(box, { subtree: true, attributes: true, attributeFilter: ['src'] });
    });
  }

  function anmelden(ctx) {
    try {
      if (!ctx || !ctx.root || ctx.root.__ehs) return;
      ctx.root.__ehs = ctx;
      if (ctx.typ === 'b') bAnmelden(ctx);
      else API.kb(ctx.root);
    } catch (e) {}
  }
  window.EhSaphir = API;
  var q = window.EHS_Q || [];
  window.EHS_Q = { push: anmelden };
  [].slice.call(q).forEach(anmelden);
})();
